import React, { useMemo } from 'react';
import { type AITTheme } from '@this/shared/ui/theme';
import { TICKET_CATEGORY, TICKET_CATEGORY_LABELS, type TicketCategory } from '../../types/proposalBundles';

type Props = {
  bundleId: number;
  selectedCategory: TicketCategory;
  onChange: (category: TicketCategory) => void;
  theme: AITTheme;
  isSpLayout?: boolean;
};

const TICKET_CATEGORY_OPTIONS: Array<{ category: TicketCategory; fareLabel: string }> = [
  { category: TICKET_CATEGORY.CHANGEABLE, fareLabel: '正規運賃' },
  { category: TICKET_CATEGORY.UNCHANGEABLE, fareLabel: '割引運賃' }
];

export const TicketCategorySelector = ({
  bundleId,
  selectedCategory,
  onChange,
  theme,
  isSpLayout = false
}: Props) => {
  const styles = useMemo(() => getStyles(theme, isSpLayout), [theme, isSpLayout]);
  const radioName = `ticketCategory-${bundleId}`;

  return (
    <div style={styles.container}>
      {TICKET_CATEGORY_OPTIONS.map(({ category, fareLabel }) => (
        <label key={category} style={styles.label}>
          <input
            type="radio"
            name={radioName}
            value={category}
            checked={selectedCategory === category}
            onChange={() => onChange(category)}
            style={styles.radio}
          />
          <span style={selectedCategory === category ? styles.labelTextActive : styles.labelText}>
            {TICKET_CATEGORY_LABELS[category]}（{fareLabel}）
          </span>
        </label>
      ))}
    </div>
  );
};

const getStyles = (theme: AITTheme, isSpLayout: boolean) => ({
  container: {
    display: 'flex',
    flexDirection: isSpLayout ? ('column' as const) : ('row' as const),
    gap: isSpLayout ? '8px' : '24px',
    marginBottom: '16px',
    padding: '12px 16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px'
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
  },
  radio: {
    width: '18px',
    height: '18px',
    accentColor: theme.linkColor,
    cursor: 'pointer'
  },
  labelText: {
    fontSize: '14px',
    color: theme.textColor
  },
  labelTextActive: {
    fontSize: '14px',
    color: theme.linkColor,
    fontWeight: 600 as const
  }
});
